export default __webpack_public_path__ + "static/media/electronic_billing.fb3f86f3.png";